var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6501 27.9417C29.5351 26.6292 29.8651 25.9584 30.5401 24.4854C25.5601 22.6479 24.7651 15.75 29.6851 13.1104C28.1851 11.2729 26.0701 10.2083 24.0751 10.2083C22.6351 10.2083 21.6451 10.5729 20.7601 10.9084C20.0101 11.1854 19.3351 11.4333 18.4951 11.4333C17.5951 11.4333 16.8001 11.1563 15.9601 10.8646C15.0451 10.5438 14.0851 10.2083 12.8851 10.2083C10.6501 10.2083 8.2651 11.5354 6.7501 13.8104C4.6201 17.0188 4.9951 23.0271 8.4301 28.1604C9.6601 29.9979 11.3101 32.0542 13.4551 32.0833C14.3551 32.0979 14.9401 31.8355 15.5851 31.5584C16.3201 31.2375 17.1151 30.8875 18.5101 30.8875C19.9051 30.8729 20.6851 31.2375 21.4201 31.5584C22.0501 31.8355 22.6201 32.0979 23.5051 32.0833C25.6801 32.0542 27.4201 29.7792 28.6501 27.9417Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7599 2.91666C23.9999 4.52082 23.3249 6.11042 22.4399 7.21876C21.4949 8.41459 19.8449 9.3479 18.2549 9.28957C17.9699 7.74373 18.7049 6.15414 19.6049 5.08956C20.6099 3.92289 22.3049 3.01874 23.7599 2.91666Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.37aaf011fc8f3bc8c54e407ef34be4e0.svg";
export { ForwardRef as ReactComponent };